import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="onboarding--import"
export default class extends Controller {
  static targets = ["template", "import", "differentApplication"]

  connect() {
    this.templateTarget.classList.add("d-none")
    this.importTarget.classList.remove("d-none")
    this.differentApplicationTarget.classList.add("d-none")
  }

  chooseApplication(event) {
    const radioButtonValue = event.target.value
    if (radioButtonValue === "different_application") {
      this.templateTarget.classList.remove("d-none")
      this.importTarget.classList.add("d-none")
      this.differentApplicationTarget.classList.remove("d-none")
    } else {
      this.templateTarget.classList.add("d-none")
      this.importTarget.classList.remove("d-none")
      this.differentApplicationTarget.classList.add("d-none")
    }
  }
}
